import { Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {BeanUsuario} from 'src/bean/BeanUsuario';
import {BeanSlideOperacao} from '../../../bean/BeanSlideOperacao';
import {MatSort} from '@angular/material/sort';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { CadastroUsuarioService } from './cadastro-usuario.service';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import { BeanOperacao } from 'src/bean/BeanOperacao';
import { BeanTipoUsuario } from 'src/bean/BeanTipoUsuario';
import { BeanSituacao } from 'src/bean/BeanSituacao';
import { BeanUsuarioPorOperacao } from 'src/bean/BeanUsuarioPorOperacao';
import { BeanMenu } from 'src/bean/BeanMenu';
import { BeanSlideMenu } from 'src/bean/BeanSlideMenu';
import { BeanUsuarioPorMenu } from 'src/bean/BeanUsuarioPorMenu';





import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AddAlertTwoTone, LeakRemoveTwoTone } from '@material-ui/icons';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import { AESEncryptDecryptService } from "../../AESEncryptDecryptService";





@Component({
  selector: 'app-cadastro-usuario',
  templateUrl: './cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.css']
})
export class CadastroUsuarioComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['usuaNmUsuario', 'usuaDsRe', 'usuaDhInativo'];
  public lstUsuarios: BeanUsuario[] = []
  public lstCmbOperacao: BeanOperacao[];
  public lstCmbSituacao: BeanSituacao[];
  public lstCmbTipoUsuario: BeanTipoUsuario[];
  public lstCmbGestao: BeanUsuario[];
  public sessionExpired: boolean = false;


  dataSource = new MatTableDataSource<BeanUsuario>(this.lstUsuarios);
  selectedIndex: number = 0;
  formControlDesligado = new FormControl('', []);
  usuarioBean : BeanUsuario;
  situacaoBean : BeanSituacao;
  operacaoBean : BeanOperacao;
  tipoUsuarioBean : BeanTipoUsuario;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';


  constructor( public dialog: MatDialog,
              private cadastroUsuarioService : CadastroUsuarioService,
              private toastr: ToastrService,
              private _snackBar: MatSnackBar,
              private router: Router,
              private _AESEncryptDecryptService: AESEncryptDecryptService
              
            ) { }

  ngOnInit(): void {

    this.listarCmbSituacao();
    this.preencheCmbOperacao();
    this.listarCmbTipoUsuario();

  }

  ngAfterContentChecked(){

    this.resetSessionExpired();
  }

  public sair() {

    this.sessionExpired = false;
    localStorage.clear();
    this.router.navigate([''])

  }

  public setSessionExpired(errorResponse:any) : boolean {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

			this.sair();
			this.toastr.warning("Sua sessão expirou, faça o login novamente!");
		}
  }


  @ViewChild('sortUsuario') sortUsuario = new MatSort();

  isRevogado = false;

  public formulario: FormGroup = new FormGroup({


    'usuaIdUsuaCdUsuario': new FormControl("", Validators.required),
    'idOperacaoMenu': new FormControl("", Validators.required),
    'idOperacao': new FormControl("", Validators.required),
    'tipoUsuario': new FormControl("", Validators.required),
    're': new FormControl("", Validators.required),
    'nome': new FormControl("", Validators.required),
    'pswrd': new FormControl("", Validators.required),
    'idGestor': new FormControl(""),
    'cargaHoraria': new FormControl("", Validators.required),


    'situacao': new FormControl("", Validators.required) ,
    'loginDac': new FormControl("", Validators.required) ,
    'dataInicioOperacional': new FormControl("", Validators.required) ,
    'dataAdmissao': new FormControl("", Validators.required),
    'isAdministrador': new FormControl(""),
    'isInativo': new FormControl(""),
    'isDesligado': new FormControl(""),
    'dataDesligamento': new FormControl("") ,
    'nomeUsuario': new FormControl("") ,
    'reUsuario': new FormControl(""),
    'formaBusca': new FormControl(""),
    'usuaInExcluirFicha': new FormControl("")

  })

  public add():void{

    if(
        this.formulario.get("tipoUsuario").value == "" ||
        this.formulario.get("re").value == ""         || this.formulario.get("nome").value == "" ||
        this.formulario.get("dataAdmissao").value == "" ||
        this.formulario.get("situacao").value == ""   ||
        this.formulario.get("dataInicioOperacional").value == "" || this.formulario.get("cargaHoraria").value == ""
      ){
           this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
        return
      }

      if(this.formulario.controls.tipoUsuario.value == 3 && this.formulario.get("loginDac").value == ""){

        this.toastr.error('O campo Login DAC é obrigatório para perfis de operador', 'Obrigatoriedade')
        return;
      }

      if(this.formulario.controls.idOperacao.value == "" && this.formulario.controls.usuaIdUsuaCdUsuario.value == ""){

        this.toastr.error('O campo operação é obrigatório', 'Obrigatoriedade')
        return;
      }

      if(this.formulario.value.tipoUsuario == 3 && this.formulario.value.idGestor == ""){

        this.toastr.error('O campo GESTOR é obrigatório para cadastro de OPERADOR', 'Obrigatoriedade');
        return ;
      }


      if(this.formulario.value.isDesligado == false){
        this.formulario.controls['dataDesligamento']. setValue("");
      }

      if(this.formulario.value.tipoUsuario != 3){
        this.formulario.controls['loginDac'].setValue(null);
      }

      this.usuarioBean = new BeanUsuario (
        this.formulario.value.usuaIdUsuaCdUsuario,
        this.formulario.value.nome,
        this.formulario.value.re,
        this.formulario.value.loginDac,
        null,                   //DATA DE REGISTRO
        this.formulario.value.dataAdmissao,
        this.formulario.value.usuaNrCargahoraria,  //CADASTRAR CARGA HORARIA NA TELA
        this.formulario.value.isDesligado == true ? 'S' : 'N',
        this.formulario.value.dataDesligamento == '' ? null : this.formulario.value.dataDesligamento,
        this.formulario.value.tipoUsuario != 3  ? null : this.formulario.value.idGestor, //CASO TIPO DE USUARIO É DOFERENTE DE OPERADOR RETIRAR O CAMPO GESTOR
        null,
        this.formulario.value.isInativo == true ? '1900-01-01T00:00:00' : null,
        this.formulario.value.tipoUsuario,   // BeanTipoUsuario
        this.formulario.value.situacao,      // BeanSituacao
        this.formulario.value.isAdministrador == true ? 'S' : 'N',
        this.formulario.value.idOperacao,      // BeanOperacao
        null,
        this.formulario.value.dataInicioOperacional == '' ? null : this.formulario.value.dataInicioOperacional,
        this.formulario.value.cargaHoraria,
        [],
        [],
        this.formulario.value.usuaInExcluirFicha == true ? 'S' : 'N',
        false
      );


      if(this.formulario.value.usuaIdUsuaCdUsuario != '' && this.formulario.value.usuaIdUsuaCdUsuario > 0){

        //EDITAR USUARIO
        this.cadastroUsuarioService.updateUsuario(this.usuarioBean).then((retorno:any)=>{

          this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')

          this.buscarUsuarios();
          this.clearFormulario();


        },
          errorResponse => {

          this.toastr.error(' Erro ao Atualizar usuario: ' + errorResponse?.error?.message , 'ERRO AO ATUALIZAR');

        })

      }else{

        //CRIAR NOVO USUARIO
        this.cadastroUsuarioService.addUsuario(this.usuarioBean).then((retorno:any)=>{

          if(retorno.usuaIdCdUsuario != null && retorno.usuaIdCdUsuario > 0){

            this.cadastroUsuarioService.addOperacaoUsuario(retorno.usuaIdCdUsuario, this.formulario.value.idOperacao).then((retorno:any)=>{

              this.buscarUsuarios();
              
              this.toastr.success(retorno.msgResponse, 'SUCESSO AO GRAVAR', {timeOut: 1000})
              this.clearFormulario();

              this.openSnackBar(retorno.usuaIdCdUsuario);

            },
              errorResponse => {
              this.toastr.error('Erro ao gravar Usuário na Operação', 'ERRO AO GRAVAR')
              this.clearFormulario();
            })
          }else{

            this.toastr.error(retorno.msgResponse, 'ERRO AO GRAVAR')
            this.clearFormulario();
          }
        },

          errorResponse => {
          this.toastr.error(' Erro ao gravar Usuário', 'ERRO AO GRAVAR')
          this.clearFormulario();
        })
      }


  }

  clearFormulario(){

    //limpar
    //this.formulario.controls['idOperacao'].setValue("");
    this.formulario.controls['usuaIdUsuaCdUsuario'].setValue(0);
    this.formulario.controls['tipoUsuario'].setValue("");
    this.formulario.controls['re'].setValue("");
    this.formulario.controls['nome'].setValue("");
    this.formulario.controls['pswrd'].setValue("");
    this.formulario.controls['idGestor'].setValue("");
    this.formulario.controls['situacao'].setValue("");
    this.formulario.controls['loginDac'].setValue("");
    this.formulario.controls['dataInicioOperacional'].setValue("");
    this.formulario.controls['dataAdmissao'].setValue("");
    this.formulario.controls['dataDesligamento'].setValue("");
    this.formulario.controls['cargaHoraria'].setValue("");
    this.formulario.controls['isDesligado'].setValue(false);
    this.formulario.controls['isInativo'].setValue(false);
    this.formulario.controls['isAdministrador'].setValue(false);
    this.formulario.controls['usuaInExcluirFicha'].setValue(false);
    this.formulario.controls['idOperacao'].setValue("");
    this.isRevogado = false;
  }

  limparBusca(){

    this.formulario.controls['idOperacaoMenu'].setValue("");
    this.formulario.controls['reUsuario'].setValue("");
    this.formulario.controls['nomeUsuario'].setValue("");
    this.formulario.controls['formaBusca'].setValue("");
    
  }

  onChangeOperacao(valorSelecionado : any){

    if(valorSelecionado.value != ""){
      this.listarCmbGestao(valorSelecionado.value);
    }
  }

  public listarUsuariosPorOperacao(idOperacao : string){

    if(idOperacao != ""){

      this.cadastroUsuarioService.listarUsuariosPorOperacoes(idOperacao).then((retorno:any)=>{
          this.dataSource = new MatTableDataSource<BeanUsuario>(retorno);

          this.dataSource.sort = this.sortUsuario;
        },
        errorResponse => { //CASO ERRO

          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Usuários');

        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });
      }
    }


    public listarCmbSituacao(){

      this.cadastroUsuarioService.listarSituacao().then((retorno:BeanSituacao[])=>{

        this.lstCmbSituacao = retorno;

      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO PRODUTOS');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }


    public listarCmbTipoUsuario(){


      this.cadastroUsuarioService.listartipoUsuario().then((retorno:BeanTipoUsuario[])=>{

        this.lstCmbTipoUsuario = retorno;

      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','LISTAR TIPO USUARIO');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }


  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  setFormUsuario(form: BeanUsuario){

    this.getAllGestor(form.usuaDsRe).then((retorno) => {

      if(this.sessionExpired){

        return;
      }

      this.toastr.success('Usuário '+form.usuaNmUsuario+' em edição','MODO EDIÇÃO')
      this.formulario.controls['idOperacao'].setValue(form.operIdCdOperacao);
      this.formulario.controls['usuaIdUsuaCdUsuario'].setValue(form.usuaIdCdUsuario);
      this.formulario.controls['tipoUsuario'].setValue(form.tiusIdCdTipoUsuario);
      this.formulario.controls['re'].setValue(form.usuaDsRe);
      this.formulario.controls['nome'].setValue(form.usuaNmUsuario);
      this.formulario.controls['pswrd'].setValue(form.usuaDsSenha);
      this.formulario.controls['idGestor'].setValue(form.usuaIdCdGestor);
      this.formulario.controls['situacao'].setValue(form.siusIdCdSituacaoUsuario);
      this.formulario.controls['loginDac'].setValue(form.usuaDsLoginDac);
      this.formulario.controls['dataInicioOperacional'].setValue(form.usuaDhInicioOperacional);
      this.formulario.controls['dataAdmissao'].setValue(form.usuaDhAdmissao);
      this.formulario.controls['cargaHoraria'].setValue(form.usuaNrCargaHoraria);
      this.formulario.controls['isInativo'].setValue(form.usuaDhInativo != null ? true : false);
      this.formulario.controls['isAdministrador'].setValue(form.usuaInAdmin == 'S' ? true : false);
      this.formulario.controls['isDesligado'].setValue(form.usuaInDesligado == 'S' ? true : false);
      this.formulario.controls['dataDesligamento'].setValue(form.usuaDhDesligamento);
      this.formulario.controls['usuaInExcluirFicha'].setValue(form.usuaInExcluirFicha == 'S' ? true : false);
      this.isRevogado = form.usuaDsSenha == null ? true : false;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }


  onClickDesligado(value: MatSlideToggleChange){
    if(!value.checked){
      this.formulario.controls['dataDesligamento'].setValue("");
    }
  }



  public preencheCmbOperacao(){

    this.cadastroUsuarioService.getListcmbOperacao().then((retorno:BeanOperacao[])=>{

        this.lstCmbOperacao = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO OPERACAO');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }



    public listarCmbGestao(idOperacao : string){

      this.cadastroUsuarioService.listarGestao(idOperacao).then((retorno:BeanUsuario[])=>{

       this.lstCmbGestao = retorno;

      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO GESTOR');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }


  loadDialogPermissoes(idUsuarioEdicao : string, reEdicao:string, nomeEdicao:string){

    const dialogRef = this.dialog.open(PermissaoUsuarioDialog,{
      width:'25%'

    });

    dialogRef.componentInstance.idUsuarioEdicao = idUsuarioEdicao;
    dialogRef.componentInstance.reEdicao = reEdicao;
    dialogRef.componentInstance.nomeEdicao = nomeEdicao;

    dialogRef.afterClosed().subscribe(result => {

    });

  }


  loadDialogEmpresas(idUsuarioEdicao:string, reEdicao:string, nomeEdicao:string){

    const dialogRef = this.dialog.open(EmpresaUsuarioDialog,{
      width:'25%'

    });

    dialogRef.componentInstance.idUsuarioEdicao = idUsuarioEdicao;
    dialogRef.componentInstance.reEdicao = reEdicao;
    dialogRef.componentInstance.nomeEdicao = nomeEdicao;


    dialogRef.afterClosed().subscribe(result => {

      if(result.sessionExpired){

        this.sessionExpired = result.sessionExpired;
        this.resetSessionExpired();

      }else{

        this.getAllGestor(this.formulario.controls.re.value);
      }

    });

  }


  public onChangeBusca(valorSelecionado:any){

    this.formulario.controls['formaBusca'].setValue(valorSelecionado.value);
    this.limparListas();
    this.clearFormulario();

  }

  public limparListas(){

    this.lstUsuarios = [];
    this.lstCmbGestao = [];

    this.dataSource = new MatTableDataSource<BeanUsuario>(this.lstUsuarios);
  }

  public buscarUsuarios(){

    this.clearFormulario();
    this.limparListas();

    if(this.formulario.controls['formaBusca'].value == "empresa"){
      this.listarUsuariosPorOperacao(this.formulario.controls.idOperacaoMenu.value);

    }else if(this.formulario.controls['formaBusca'].value == "re"){

      if(this.formulario.get("reUsuario").value.length < 3){
        this.toastr.info("Digite pelo menos 3 caracteres", "Lista Usuários")

      }else{
        this.getUserByRe();
      }

    }else if(this.formulario.controls['formaBusca'].value == "nome"){

      if(this.formulario.get("nomeUsuario").value.length < 3){
        this.toastr.info("Digite pelo menos 3 caracteres", "Lista Usuários")

      }else{
        this.getUserByNmUsuario();
      }

    }
  }

  public getAllGestor(re: string) : Promise<any>{

    this.lstCmbGestao = [];

    return this.cadastroUsuarioService.getUsuarioPorRe(re).then((beanUsuario: BeanUsuario) => {

      if(beanUsuario.usuaIdCdGestor != null && beanUsuario.usuaIdCdGestor != ""){

        this.cadastroUsuarioService.getUsuarioPorId(Number(beanUsuario.usuaIdCdGestor)).then((gestorAtual: BeanUsuario) => {

          this.lstCmbGestao.push(gestorAtual);

        }, errorResponse => {

          this.setSessionExpired(errorResponse);
        });
      }

      beanUsuario.operations.forEach(operation => {

        this.cadastroUsuarioService.listarGestao(operation.operIdCdOperacao).then((gestores:BeanUsuario[])=>{

          gestores.forEach(gestor => {

            if(this.lstCmbGestao.find(g => g.usuaIdCdUsuario === gestor.usuaIdCdUsuario) == undefined){

              this.lstCmbGestao.push(gestor);
            }
          });
         }, errorResponse => {

          this.setSessionExpired(errorResponse);

         });
      });
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })
  }

  openSnackBar(idUsuario: string) {


    //ABRIR A MENSAGEM SNACKBAR
    let snack =  this._snackBar.open('Deseja editar o usuário que acabou de criar?', 'Clique aqui', {

      duration: 10000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });

    snack.onAction().subscribe(() => {

      this.limparBusca();
      this.limparListas();
      this.clearFormulario();

      this.cadastroUsuarioService.getUsuarioPorId(Number(idUsuario)).then((beanUsuario: BeanUsuario) => {

        this.setFormUsuario(beanUsuario);
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

    });
  }


  public getUserByRe(){

    this.cadastroUsuarioService.getUsuarioPorRe(this.formulario.get("reUsuario").value).then((retorno:BeanUsuario)=>{

      if(retorno == null){
        return this.toastr.info('Nenhum usuário encontrado','Lista Usuários');
      }

      const beanUsuario:BeanUsuario = retorno;
      const listUsuario: BeanUsuario[] = [];
      listUsuario.push(beanUsuario);

      this.dataSource = new MatTableDataSource<BeanUsuario>(listUsuario);

      this.dataSource.sort = this.sortUsuario;



    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Nenhum usuário encontrado','Lista Usuários');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }

  public getUserByNmUsuario(){

    this.cadastroUsuarioService.getUsuarioByName(this.formulario.get("nomeUsuario").value).then((retorno:BeanUsuario[])=>{

      this.dataSource = new MatTableDataSource<BeanUsuario>(retorno);

      this.dataSource.sort = this.sortUsuario;



    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Nenhum usuário encontrado','Lista Usuários');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }

  public revogarSenha(){

    if(this.formulario.controls.usuaIdUsuaCdUsuario.value != ""){

      this.cadastroUsuarioService.getUsuarioPorId(this.formulario.controls.usuaIdUsuaCdUsuario.value).then((beanUsuario: BeanUsuario) => {

        beanUsuario.usuaDsSenha = null;
        beanUsuario.isRevogarSenha = true;

        this.cadastroUsuarioService.updateUsuario(beanUsuario).then((beanUsuario: BeanUsuario) => {


          this.isRevogado = beanUsuario.usuaDsSenha == null ? true : false;

          this.toastr.success(`A senha para ${beanUsuario.usuaNmUsuario} foi revogada com sucesso!`);


          if(this.formulario.controls.usuaIdUsuaCdUsuario.value == this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser'))){

            localStorage.clear();
            this.router.navigate([''])

          }

        }, errorResponse => {

          this.setSessionExpired(errorResponse);
        })
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })
    }
  }
}











@Component({
  selector: 'dialog-permissao-pendencias',

  templateUrl: 'dialog-permissao-cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.css'],
  providers : [CadastroUsuarioService]
})
export class PermissaoUsuarioDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CadastroUsuarioComponent>,
    private cadastroUsuarioService : CadastroUsuarioService,
    private toastr: ToastrService,
    private router: Router,
    private _AESEncryptDecryptService: AESEncryptDecryptService

  ) { }

  public idUsuarioEdicao : string = "";
  public reEdicao : string = "";
  public nomeEdicao : string = "";

  public lstMenu: BeanMenu[]=[];
  public lstSlideMenus: BeanSlideMenu[]=[];



  ngOnInit(): void {
    this.preencheSlideMenu();
  }

  ngAfterViewInit() {

  }

  public preencheSlideMenu(){


    this.cadastroUsuarioService.getListcmbMenu().then((retornoAllMenu:BeanMenu[])=>{

        this.cadastroUsuarioService.getUsuarioPorRe(this.reEdicao).then((retornoAllMenuByUser:BeanUsuario)=>{


          //todas as operações
          for(let i = 0; i < retornoAllMenu.length; i++ ){

            let slide : boolean = false;

            //operações do usuário
            for(let j = 0; j < retornoAllMenuByUser.menus.length; j++ ){


              let idAllMenus = retornoAllMenu[i].menuIdCdMenu;
              let idUserMenus = retornoAllMenuByUser.menus[j].menuIdCdMenu;

              if(idAllMenus == idUserMenus ){
                 slide =  true;
                 break;
              }

            }

           let adicionarItem =  new BeanSlideMenu(retornoAllMenu[i].menuIdCdMenu,
                                                  retornoAllMenu[i].menuNmMenu,
                                                  retornoAllMenu[i].menuDhInativo,
                                                  slide);

            this.lstSlideMenus.push(adicionarItem)

          }

        }, errorresponse => {
            this.toastr.error('Erro conexao backend\nContate o suporte.','MENUS');

        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });

    }, errorresponse => {
        this.toastr.error('Erro conexao backend\nContate o suporte.','MENUS');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }

  getSlideButton(value: MatSlideToggleChange, idMenu : string) {

    if(value.checked){

            this.cadastroUsuarioService.insertEmpresaParaMenu(this.idUsuarioEdicao, idMenu).then((retorno:BeanUsuarioPorMenu)=>{
              this.toastr.success('Menu vinculado ao usuário','MENU VINCULADO');

            }, errorresponse => {
              this.toastr.error('Erro conexao backend\nContate o suporte.','MENU POR USUARIO');

            }).catch((retorno:any) => {

              if(retorno.error.error_description.indexOf("Access token expired")>-1){
                  alert("Sessão Expirada");
                  this.router.navigate(['']);
                }
            });


    }else if(!value.checked){


      this.cadastroUsuarioService.getUsuarioPorRe(this.reEdicao).then((retornoAllMenuByUser:BeanUsuario)=>{

        if(retornoAllMenuByUser.menus.length > 1){

              this.cadastroUsuarioService.deleteUsuarioParaMenu(this.idUsuarioEdicao, idMenu).then((retorno:any)=>{
                this.toastr.success('Menu vinculado ao usuário retirado','MENU DESVINCULADO');

              }, errorresponse => {

                if(errorresponse.status == 200){
                  this.toastr.success('Retirado vinculo do menu para o usuário','MENU DESVINCULADO');
                }else{
                  this.toastr.error('Erro conexao backend\nContate o suporte.','MENU POR USUARIO');
                }

              }).catch((retorno:any) => {

                if(retorno.error.error_description.indexOf("Access token expired")>-1){
                    alert("Sessão Expirada");
                    this.router.navigate(['']);
                  }
              });

        }else{

          this.toastr.error('É necessário deixar o usuário vinculado à pelomenos um menu.','MENU POR USUARIO');
          setTimeout(()=>{
            this.lstSlideMenus=[];
            this.preencheSlideMenu();
          }, 200);

        }


      }, errorresponse => {
          this.toastr.error('Erro conexao backend\nContate o suporte.','MENUS');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });






    }

  }

}









@Component({
  selector: 'dialog-empresa-cadastro-usuario',

  templateUrl: 'dialog-empresa-cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.css'],
  providers : [CadastroUsuarioService]
})
export class EmpresaUsuarioDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CadastroUsuarioComponent>,
    private cadastroUsuarioService : CadastroUsuarioService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  public idUsuarioEdicao : string = "";
  public reEdicao : string = "";
  public nomeEdicao : string = "";

  public lstOperacao: BeanOperacao[]=[];
  public lstSlideOperacao: BeanSlideOperacao[]=[];
  public sessionExpired: boolean = false;



  ngOnInit(): void {
    this.preencheSlideOperacao();
  }

  ngAfterContentChecked(){

    this.resetSessionExpired();
  }

  public setSessionExpired(errorResponse:any) {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({sessionExpired:true}));
		}
  }

  public preencheSlideOperacao(){


    this.cadastroUsuarioService.getListcmbOperacao().then((retornoAllOperacoes:BeanOperacao[])=>{

        this.cadastroUsuarioService.getUsuarioPorRe(this.reEdicao).then((retornoAllOperacoesByUser:BeanUsuario)=>{


          //todas as operações
          for(let i = 0; i < retornoAllOperacoes.length; i++ ){

            let slide : boolean = false;

            //operações do usuário
            for(let j = 0; j < retornoAllOperacoesByUser.operations.length; j++ ){


              let idAllOperacao = retornoAllOperacoes[i].operIdCdOperacao;
              let idUserOperacao = retornoAllOperacoesByUser.operations[j].operIdCdOperacao;

              if(idAllOperacao == idUserOperacao ){
                 slide =  true;
                 break;
              }

            }

           let adicionarItem =  new BeanSlideOperacao(retornoAllOperacoes[i].operIdCdOperacao,
              retornoAllOperacoes[i].operNmOperacao,
              retornoAllOperacoes[i].operDsCentroCusto,
              retornoAllOperacoes[i].operDhInativo,
              retornoAllOperacoes[i].operIdCdOperacao,
              slide);

            this.lstSlideOperacao.push(adicionarItem)

          }


        }, errorResponse => {

          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','USUARIO');

        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });


    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO OPERACAO');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }



  getSlideButton(value: MatSlideToggleChange, idOperacao : string) {


    if(value.checked){

            this.cadastroUsuarioService.insertEmpresaParaUsuario(this.idUsuarioEdicao, idOperacao).then((retorno:BeanUsuarioPorOperacao)=>{
              this.toastr.success(retorno.msgResponse,'EMPRESA VINCULADA');


            }, errorResponse => {
              this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO PRODUTOS');

            }).catch((retorno:any) => {

              if(retorno.error.error_description.indexOf("Access token expired")>-1){
                  alert("Sessão Expirada");
                  this.router.navigate(['']);
                }
            });

    }else if(!value.checked){

            this.cadastroUsuarioService.getUsuarioPorRe(this.reEdicao).then((retornoAllOperacoesByUser:BeanUsuario)=>{

              if(retornoAllOperacoesByUser.operations.length > 1){

                    this.cadastroUsuarioService.deleteUsuarioParaOperacao(this.idUsuarioEdicao, idOperacao).then((retorno:any)=>{
                      this.toastr.success('Removido vinculo de Operação para o Usuário ','OPERAÇÃO DESVINCULADO');

                    }, errorResponse => {

                      if(!this.setSessionExpired(errorResponse)){

                        if(errorResponse.status == 200){
                          this.toastr.success('Retirado vinculo do Operação para o Usuário','OPERAÇÃO DESVINCULADO');
                        }else{
                          this.toastr.error('Erro conexao backend\nContate o suporte.','OPERAÇÃO POR USUARIO');
                        }
                      }

                    }).catch((retorno:any) => {

                      if(retorno.error.error_description.indexOf("Access token expired")>-1){
                          alert("Sessão Expirada");
                          this.router.navigate(['']);
                        }
                    });

              }else{

                this.toastr.error('É necessário deixar o usuário vinculado à pelomenos uma operação.','MENU POR USUARIO');
                setTimeout(()=>{
                  this.lstSlideOperacao=[];
                  this.preencheSlideOperacao();
                }, 200);

              }


            }, errorResponse => {

              this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','MENUS');

            }).catch((retorno:any) => {

              if(retorno.error.error_description.indexOf("Access token expired")>-1){
                  alert("Sessão Expirada");
                  this.router.navigate(['']);
                }
            });

    }

  }

}

